import { createContext, useContext, useState, useCallback } from "react";

/**
 * ChatHeaderContext
 *
 * Cho phép ChatPage đăng ký dữ liệu (tab, filters, managers, tags, user, shops, ...)
 * để TopNavBar (nằm trong Layout, trên ChatPage trong cây render) có thể hiển thị
 * menu ngang đầy đủ.
 */
const ChatHeaderContext = createContext({
  headerData: null,
  setHeaderData: () => {},
  clearHeaderData: () => {},
});

export const ChatHeaderProvider = ({ children }) => {
  const [headerData, setHeaderDataState] = useState(null);

  const setHeaderData = useCallback((data) => {
    setHeaderDataState(data);
  }, []);

  const clearHeaderData = useCallback(() => {
    setHeaderDataState(null);
  }, []);

  return (
    <ChatHeaderContext.Provider
      value={{ headerData, setHeaderData, clearHeaderData }}
    >
      {children}
    </ChatHeaderContext.Provider>
  );
};

export const useChatHeader = () => useContext(ChatHeaderContext);

export default ChatHeaderContext;
